





















































































































































import Vue from 'vue';
import cloneDeep from 'lodash/cloneDeep';
import ItemList from '@/components/item/ItemList.vue';
import EnemyList from '@/components/enemy/EnemyList.vue';
import EnemyInput from '@/components/enemy/EnemyInput.vue';
import Enemy from '@/classes/enemy/enemy';
import EnemyMaster from '@/classes/enemy/enemyMaster';
import ItemMaster from '@/classes/item/itemMaster';
import Item from '@/classes/item/item';
import SaveData from '@/classes/saveData/saveData';

export default Vue.extend({
  name: 'EditableEnemyList',
  components: {
    ItemList,
    EnemyList,
    EnemyInput,
  },
  data: () => ({
    items: [] as ItemMaster[],
    defaultEnemies: [] as EnemyMaster[],
    manualEnemies: [] as EnemyMaster[],
    editingEnemy: undefined as undefined | Enemy,
    enemyListDialog: false,
    enemyEditDialog: false,
    itemListDialog: false,
    itemDialogWidth: 1200,
    editingItemIndex: 0,
  }),
  mounted() {
    this.items = this.$store.state.items as ItemMaster[];
    this.defaultEnemies = this.$store.state.defaultEnemies as EnemyMaster[];
    const dbManualEnemies = this.$store.state.manualEnemies as EnemyMaster[];
    if (dbManualEnemies && dbManualEnemies.length) {
      this.manualEnemies = dbManualEnemies;
    }
  },
  computed: {
    manualEnemyRows(): Enemy[] {
      const rows = [];
      const enemies = this.manualEnemies;
      for (let i = 0; i < enemies.length; i += 1) {
        const enemy = enemies[i];
        rows.push(Enemy.createEnemyFromMaster(enemy, false, this.items));
      }
      return rows;
    },
    disabledDelete(): boolean {
      const enemy = this.editingEnemy;
      if (enemy) {
        return !this.manualEnemies.some((v) => v.id === enemy.data.id);
      }
      return false;
    },
  },
  methods: {
    showEnemyList() {
      this.enemyListDialog = true;
    },
    putEnemy(enemy: EnemyMaster) {
      if (enemy && enemy.id) {
        this.editingEnemy = Enemy.createEnemyFromMaster(cloneDeep(enemy), false, this.items);
        this.enemyEditDialog = true;
      }
    },
    showEditedEnemy(index: number) {
      const dbManualEnemies = this.$store.state.manualEnemies as EnemyMaster[];
      const enemy = dbManualEnemies[index];
      if (enemy) {
        this.editingEnemy = Enemy.createEnemyFromMaster(enemy, false, this.items);
        this.enemyEditDialog = true;
      }
    },
    async showItemList(slotIndex: number) {
      const enemy = this.editingEnemy;
      if (enemy) {
        this.editingItemIndex = slotIndex;
        await (this.itemListDialog = true);
        (this.$refs.itemList as InstanceType<typeof ItemList>).initialFilter(enemy, slotIndex);
      }
    },
    equipItem(item: Item) {
      const enemy = this.editingEnemy;
      if (!enemy) {
        return;
      }
      enemy.items[this.editingItemIndex] = new Item({ item, level: 0 });
      this.editingEnemy = new Enemy(enemy.data, enemy.items);
      this.itemListDialog = false;
    },
    onChanged() {
      const enemy = this.editingEnemy;
      if (!enemy) {
        return;
      }
      this.editingEnemy = new Enemy(enemy.data, enemy.items);
    },
    resetEditingEnemy() {
      // サーバー値にリセット
      const enemy = this.editingEnemy;
      if (!enemy) {
        return;
      }
      const master = this.defaultEnemies.find((v) => v.id === enemy.data.id);
      if (master) {
        this.editingEnemy = Enemy.createEnemyFromMaster(cloneDeep(master), false, this.items);
      }
    },
    commitManualEnemy() {
      // 手動敵艦を削除
      const newManualEnemies = this.manualEnemies.concat();
      // 現在選択の敵艦データを挿入
      if (this.editingEnemy) {
        const newEnemy = this.editingEnemy.data;
        // 搭載と装備を更新
        newEnemy.slots = this.editingEnemy.items.map((v) => v.fullSlot);
        newEnemy.items = this.editingEnemy.items.map((v) => v.data.id);

        // 更新か追加か
        const index = newManualEnemies.findIndex((v) => v.id === newEnemy.id);
        if (index >= 0) {
          newManualEnemies[index] = newEnemy;
        } else {
          newManualEnemies.push(newEnemy);
        }
        this.$store.dispatch('updateManualEnemies', newManualEnemies);
        this.updatedEnemy(newEnemy);

        this.manualEnemies = newManualEnemies;
        this.enemyEditDialog = false;
      }
    },
    deleteManualEnemy() {
      // 手動敵艦を削除
      let newManualEnemies = this.manualEnemies.concat();
      // 現在選択のidを削除
      if (this.editingEnemy) {
        const { id } = this.editingEnemy.data;
        newManualEnemies = newManualEnemies.filter((v) => v.id !== id);
        this.$store.dispatch('updateManualEnemies', newManualEnemies);

        const defaultEnemies = this.defaultEnemies.find((v) => v.id === id);
        if (defaultEnemies) {
          this.updatedEnemy(defaultEnemies);
        }

        this.manualEnemies = newManualEnemies;
        this.enemyEditDialog = false;
      }
    },
    closeEnemyList() {
      this.enemyListDialog = false;
    },
    closeItemDialog() {
      this.itemListDialog = false;
    },
    changeWidth(width: number) {
      this.itemDialogWidth = width;
    },
    updatedEnemy(enemy: EnemyMaster) {
      // セーブデータルート取得
      const saveData = this.$store.state.saveData as SaveData;
      if (!saveData) {
        return;
      }
      const activeData = saveData.fetchActiveData();
      for (let i = 0; i < activeData.length; i += 1) {
        // 全履歴内の該当敵艦を置き換えて再計算
        activeData[i].updateEnemyMasterInCalcData(enemy, this.items);
      }
      const mainSaveData = saveData.getMainData();
      if (mainSaveData) {
        // 計算開始
        this.$store.dispatch('setMainSaveData', mainSaveData);
      } else {
        this.$router.push('/');
      }
    },
  },
});
